module.exports = __webpack_public_path__ + "img/rclx.f772bac8.png";